module.exports = __webpack_public_path__ + "static/img/img1.3cf4a54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/english2/img1.png
// module id = PdUc
// module chunks = 1